import { lazy, Suspense } from 'react';
import Loading from '../MatxLoading';

const Layout = lazy(() => import('./Layout1/Layout1'));

const MatxSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

const MatxLayout = (props) => {
  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
};

export default MatxLayout;
